import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate, useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import * as svg from '@progress/kendo-svg-icons';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { toast } from 'react-toastify';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { IMention } from '../../../../../../types/User/IMention';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import ExistingTickets from '../../../../GridControls/ExistingTickets';
import { SvgIcon } from '@progress/kendo-react-common';

const RelatedTicketsModal: React.FC = () => {
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    let { data: staffList, isLoading: staffLoading } = UserApi.useGetMentionQuery('');
    const { data: ticket, isLoading } = TicketApi.useGetTicketDetailsQuery({ ticketId: parseInt(ticketId) });
    const [value, setValue] = React.useState<IMention[]>([]);
    const [error, setError] = React.useState<string>();
    const [filter, setFilter] = useState<FilterDescriptor>({ operator: 'contains' })
    const filteredStaff = useMemo(() => staffList?.length && filter?.value ? filterBy(staffList?.slice(), filter) : staffList, [filter, staffList]);
    const [formState, setFormState] = useState({ isParent: false, parentCallId: 0 });
    const [updateHierarchy, { isLoading: updatingTicket, error: saveTicketError }] = TicketApi.useUpdateTicketHierarchyMutation();
    const [removeHierarchy, { isLoading: removingHierarchy, error: removeError }] = TicketApi.useRemoveTicketHierarchyMutation();

    //Set the ticket details into the formstate
    useEffect(() => {
        if (ticket)
            setFormState({ isParent: ticket.Is_Parent, parentCallId: ticket.Parent_Call_Id > 0 ? ticket.Parent_Call_Id : null });
    }, [ticket]);


    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        console.log('Filter', event);
        //setStaff(filterBy(staffList?.slice(), event.filter));
        setFilter(event.filter);
    }

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const onWindowClose = () => {
        navigate('/ticket/' + ticketId);
    }

    if (!filteredStaff || !userProfile?.Features.Call_Hierarchy) return <></>;

    return (
        <div>
            <Window modal={true} className='cool-window' minimizeButton={() => null} title={<><SvgIcon icon={svg.clockArrowRotateIcon} size='large' />&nbsp;Open {userProfile?.Phrases.CallPhrase}s ({ticket.Open_User_Tickets} / {ticket.Open_Client_Tickets})</>} onClose={onWindowClose} initialHeight={Math.min(850, window.innerHeight)} initialWidth={Math.min(1200, window.innerWidth)} stage={stage} onStageChange={onStageChange} >
                <div className='position-relative'>
                    <div id='error-summary'>
                        {error && <div className={"k-messagebox k-messagebox-error"}>{error}</div>}
                        {/* Validation */}
                        {removeError?.["data"] && removeError?.["data"] && (
                            <div className={"k-messagebox k-messagebox-error"}>
                                {removeError["data"]?.Message || removeError["data"]}
                            </div>)}
                    </div>
                    {(isLoading || updatingTicket || removingHierarchy) && <PartialSpinny />}
                    <ExistingTickets {...ticket} Is_Loading={false} />
                </div>
                <WindowActionsBar>
                    {/* <Button onClick={saveChanges} svgIcon={svg.saveIcon} type='submit' className='justify-content-end p-2' style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                        Save
                    </Button> */}
                    <Button fillMode='outline' onClick={() => onWindowClose()} svgIcon={svg.cancelIcon} className='justify-content-end p-2' style={{ marginTop: '20px' }}>
                        Cancel
                    </Button>
                </WindowActionsBar>
            </Window>
        </div>
    );
};

export default RelatedTicketsModal;